/*!
 * Copyright (C) Octillion Media LLC 2019
 * All Rights Reserved.
 */
import {
    getCreatives,
    getCreativeExistingAssetsApi,
    getCreativeApprovalHistories,
    getCreativeApprovalQueues
} from "../../helpers/api";

export const state = {
    creatives: {},
    creativeLoader: false,
    existingAssets: [],
    creativeApprovalHistories: {},
    creativeApprovalStatus: {}
};

export const getters = {
    creatives: state => state.creatives,
    creativeLoader: state => state.creativeLoader,
    existingAssets: state => state.existingAssets,
    creativeApprovalHistories: state => state.creativeApprovalHistories,
    creativeApprovalStatus: state => state.creativeApprovalStatus
};

export const mutations = {
    setCreatives(state, newValue) {
        state.creatives = newValue
    },
    setCreativeLoader(state, newValue) {
        state.creativeLoader = newValue
    },
    setExistingAssets(state, newValue) {
        state.existingAssets = newValue
    },
    setCreativeApprovalHistories(state, newValue) {
        state.creativeApprovalHistories = newValue
    },
    setCreativeApprovalStatus(state, newValue) {
        state.creativeApprovalStatus = newValue
    },
    clearExistingAssetsData(state) {
        state.existingAssets = [];
    }
};

export const actions = {
    fetchCreatives({commit}, payload) {
        commit('setCreativeLoader', true);
        getCreatives(payload).then(res => {
            commit('setCreatives', res.data)
            commit('setCreativeLoader', false);
        }, (error) => {
            commit('setCreativeLoader', false);
            commit('setCreativeErr', error.data)
        })
    },
    fetchCreativeApprovalHistories({commit}, payload) {
        getCreativeApprovalHistories(payload).then(res => {
            commit('setCreativeApprovalHistories', res.data)
        }, (error) => {
            commit('setCreativeApprovalHistories', {})
        })
    },
    fetchCreativeApprovalStatus({commit}, payload) {
        getCreativeApprovalQueues(payload).then(res => {
            commit('setCreativeApprovalStatus', res.data)
        }, (error) => {
            commit('setCreativeApprovalStatus', {})
        })
    },
    fetchExistingAssets({commit}, payload) {
        getCreativeExistingAssetsApi(payload).then(res => {
            commit('setExistingAssets', res.data)
        })
    },
    clearExistingAssets({ commit }) {
        commit('clearExistingAssetsData')
    }
};